type QueryParams = {
  [key: string]: string | number | boolean
}

export function create(queryParams: QueryParams = {}): string {
  return Object.keys(queryParams)
    .sort()
    .map(param => `${param}=${encodeURIComponent(queryParams[param])}`)
    .join('&');
}
